// Sort utilities to consistently show newest items first across tables

function getFirstDateValue(item) {
  const candidates = [
    item?.created_at,
    item?.createdAt,
    item?.updated_at,
    item?.updatedAt,
    item?.inspection_date,
    item?.inspectionDate,
    item?.scheduledDate,
    item?.upload_date,
    item?.uploaded_at,
    item?.date,
    item?.dueDate,
    item?.timestamp
  ];

  for (let i = 0; i < candidates.length; i += 1) {
    const value = candidates[i];
    if (!value) continue;
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) return d.getTime();
  }
  return 0;
}

export function sortNewestFirst(items) {
  if (!Array.isArray(items)) return items;
  return [...items].sort((a, b) => {
    const bTime = getFirstDateValue(b);
    const aTime = getFirstDateValue(a);
    // Newest first
    if (bTime !== aTime) return bTime - aTime;
    // Fallback stable tie-breakers
    const bId = typeof b?.id === 'number' ? b.id : 0;
    const aId = typeof a?.id === 'number' ? a.id : 0;
    return bId - aId;
  });
}

export function insertNewestFirst(currentItems, newItem) {
  // Ensure new item appears at the top regardless of existing order
  return sortNewestFirst([newItem, ...(currentItems || [])]);
}


